import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Hidden} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

import {PROPERTY as PERIOD_VALUE_PROPERTY} from "../PeriodValue"


export const PROPERTY = "preferences.questionCount"


export const schema = (props, required) => {
  return Validation.number(required ? props.formatMessage({id: "insights.validation.required"}) : null)
}

const SCHEDULE_PERIOD_VALUE_PROPERTY = `schedule[${PERIOD_VALUE_PROPERTY}]`


class AutoQuestionCount extends Component {
  /** First run */
  constructor(props) {
    super(props)
    this.periodValue = get(props, SCHEDULE_PERIOD_VALUE_PROPERTY)

    /** Initial sync */
    this.syncQuestionCountToPeriodValue(get(props, SCHEDULE_PERIOD_VALUE_PROPERTY))
  }

  /** Listen for any props changes and potentially trigger a sync */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextPeriodValue = get(nextProps, SCHEDULE_PERIOD_VALUE_PROPERTY)

    this.syncQuestionCountToPeriodValue(nextPeriodValue)
  }

  /** Do the logic check to determine whether a sync is needed */
  syncQuestionCountToPeriodValue(nextPeriodValue) {
    if (nextPeriodValue !== this.periodValue) {
      this.periodValue = nextPeriodValue

      let questionCount = 5
      if (nextPeriodValue > 2) {
        questionCount = 15
      } else if (nextPeriodValue > 1) {
        questionCount = 10
      }

      this.handleChange(questionCount)
    }
  }

  /** Dispatch value changes for the property */
  handleChange = (value) => {
    this.props.onChange(this.props.schedule, PROPERTY, value)
  }

  /** Using a hidden text field to enforce validation */
  render() {
    const idNamespace = id("AutoQuestionCount", this.props)
    const {schedule, required, validation} = this.props

    const intlValidation = validation || schema(this.props, required)

    return (
      <Hidden
        id={idNamespace}
        name={PROPERTY}
        value={get(schedule, PROPERTY)}
        validation={intlValidation} />
    )
  }
}

AutoQuestionCount.propTypes = {
  intl: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  validation: PropTypes.object,
  formatMessage: PropTypes.func.isRequired
}

AutoQuestionCount.defaultProps = {
  required: true,
  validation: null
}

export default injectIntl(AutoQuestionCount)
